module.exports = __webpack_public_path__ + "static/map-with-bg-459583da19eac07e1664229a6b111929.jpg";